enum HomeDeliveryLevelEnum {
	market = 'market',
	zip = 'zip',
	unsupported = 'unsupported'
}

export default HomeDeliveryLevelEnum;
